import React, { useEffect, useState, useRef } from "react";
import {
  getAllDepartment,
  addDepartment,
  updateDepartment,
  deleteDepartment,
} from "../../api/departmentApi";

import { hasRight } from "../../utils/userRights";

export default function Department() {
  const [departments, setDepartments] = useState([]);
  const [formData, setFormData] = useState({
    departmentName: "",
    incharge: "",
    departmentDescription: "",
  });
  const [editId, setEditId] = useState(null);

  const formRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const deptData = await getAllDepartment();
      setDepartments(deptData.data || deptData);
    } catch (error) {
      console.error("Error fetching departments", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.departmentName.trim()) {
      alert("Department Name is required.");
      return;
    }
    try {
      if (editId) {
        await updateDepartment(editId, formData);
        alert("Department updated successfully ✅");
      } else {
        await addDepartment(formData);
        alert("Department created successfully 🎉");
      }
      setFormData({ departmentName: "", incharge: "", departmentDescription: "" });
      setEditId(null);
      fetchData();
    } catch (error) {
      console.error("Error saving department", error);
      alert("Something went wrong while saving department.");
    }
  };

  const handleEdit = (item) => {
    setFormData({
      departmentName: item.departmentName,
      incharge: item.incharge || "",
      departmentDescription: item.departmentDescription || "",
    });
    setEditId(item.departmentID);

    formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this department?")) {
      try {
        await deleteDepartment(id);
        alert("Department deleted successfully 🗑️");
        fetchData();
      } catch (error) {
        console.error("Error deleting department", error);
        alert("Failed to delete department");
      }
    }
  };

  
  const handleClear = () => {
    setFormData({ departmentName: "", departmentDescription: "", incharge: "" });
    setEditId(null);
  };

   return (
  <div className="container mt-4 compact-table-container">
    {/* Heading */}
    <h4 className="compact-heading">Department Details</h4>

    {/* Add / Edit Form */}
    <form ref={formRef} className="row g-2 mt-0 compact-form" onSubmit={handleSubmit}>
      <div className="col-md-3">
        <label className="form-label">
          Department Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          value={formData.departmentName}
          onChange={(e) =>
            setFormData({ ...formData, departmentName: e.target.value })
          }
          required
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">Incharge</label>
        <input
          type="text"
          className="form-control"
          value={formData.incharge}
          onChange={(e) =>
            setFormData({ ...formData, incharge: e.target.value })
          }
        />
      </div>

      <div className="col-md-4">
        <label className="form-label">Description</label>
        <input
          type="text"
          className="form-control"
          value={formData.departmentDescription}
          onChange={(e) =>
            setFormData({ ...formData, departmentDescription: e.target.value })
          }
        />
      </div>

      <div className="col-md-2 d-flex align-items-end" >
        {/* <button type="submit" className="btn btn-success me-1">
          {editId ? "Update" : "Add"}
        </button> */}

        {(!editId && hasRight("DepartmentMaster", "add")) ||
        (editId && hasRight("DepartmentMaster", "update")) ? (
          <button type="submit" className="btn btn-success me-1">
            {editId ? "Update" : "Add"}
          </button>
        ) : null}

        <button type="button" className="btn btn-secondary" onClick={handleClear}>
          Clear
        </button>
      </div>
    </form>

    {/* Table */}
    <div className="compact-table-container mt-2">
      <table className="compact-table">
        <thead>
          <tr>
            <th>Sr</th>
            <th>Department Name</th>
            {/* <th>Incharge</th> */}
            {/* <th>Description</th> */}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {departments.length > 0 ? (
            departments.map((item, index) => (
              <tr key={item.departmentID || index}>
                <td>{index + 1}</td>
                <td>{item.departmentName}</td>
                {/* <td>{item.incharge || "-"}</td> */}
                {/* <td>{item.description || "-"}</td> */}
                <td>
                  {/* <button className="edit" onClick={() => handleEdit(item)}>Edit</button>
                  <button className="delete" onClick={() => handleDelete(item.departmentID)}>Delete</button> */}
                  
                  {/* Edit button → only show if user has Update right */}
                  {hasRight("DepartmentMaster", "update") && (
                    <button className="edit" onClick={() => handleEdit(item)}>
                      Edit
                    </button>
                  )}
                
                  {/* Delete button → only show if user has Delete right */}
                  {hasRight("DepartmentMaster", "delete") && (
                    <button
                      className="delete"
                      onClick={() => handleDelete(item.departmentID)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No Departments found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

}

